import React from "react";
import img1 from "../../assets/img1.jpg";
import img2 from "../../assets/img2.jpg";
import img3 from "../../assets/img3.jpg";
import img4 from "../../assets/img4.jpg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Form, Badge, } from "react-bootstrap";

const rooms = [
  {
    name: "Standard",
    size: "25 m²",
    bed: "Queen Bed",
    guests: "2 guests",
    adults: 2,
    children: 0,
    status: "Occupied",
    availability: "22/30 Rooms",
    price: "₹3,500",
    image: img1,
  },
  {
    name: "Deluxe",
    size: "35 m²",
    bed: "King Bed",
    guests: "2 guests",
    adults: 2,
    children: 1,
    status: "Available",
    availability: "18/25 Rooms",
    price: "₹5,500",
    image: img2,
  },
  {
    name: "Suite",
    size: "50 m²",
    bed: "King Bed",
    guests: "3 guests",
    adults: 2,
    children: 1,
    status: "Available",
    availability: "8/10 Rooms",
    price: "₹9,000",
    image: img3,
  },
  {
    name: "Family",
    size: "45 m²",
    bed: "2 Queen Beds",
    guests: "4 guests",
    adults: 2,
    children: 2,
    status: "Occupied",
    availability: "12/15 Rooms",
    price: "₹7,500",
    image: img4,
  },
];

export default function Rooms() {


  const navigate = useNavigate();


  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive" onClick={() => navigate("/admin/rooms")}>Rooms</span>
        </div>

        {/* Right: Button */}
        <Button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/addhotelrooms")}
        >
          Add Rooms
        </Button>
      </div>
      
      <Container fluid className="p-4 bg-light">

        {/* Top controls */}
        <Row className="mb-4 align-items-center">
          <Col md={6}>
            <Form.Control placeholder="Search room type, number, etc" />
          </Col>

          <Col md={6} className="d-flex justify-content-end gap-2 mt-2 mt-md-0">
            <Form.Select className="w-auto">
              <option>Popular</option>
              <option>Price</option>
            </Form.Select>

            <Form.Select className="w-auto">
              <option>All Type</option>
            </Form.Select>
          </Col>
        </Row>

        {/* Room Cards */}
        <Row className="g-4">
          {rooms.map((room, index) => (
            <Col xs={12} key={index}>
              <Card
                className="border-0 shadow-sm"
                style={{
                  transition: "0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 28px rgba(0,0,0,0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(0,0,0,0.08)";
                }}
              >
                <Card.Body>
                  <Row className="align-items-center">
                    {/* Image */}
                    <Col md={4}>
                      <img
                        src={room.image}
                        alt={room.name}
                        className="img-fluid rounded"
                        style={{
                          height: "180px",
                          width: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Col>

                    {/* Content */}
                    <Col md={6}>
                      <h4 className="mb-1">{room.name}</h4>

                      <div className="text-muted mb-2">
                        {room.size} • {room.bed}
                      </div>

                      <div className="text-muted mb-2">
                        {room.adults} Adults • {room.children} Children
                      </div>

                      <p className="text-muted small mb-2">
                        Comfortable stay with modern amenities, elegant interiors,
                        and relaxing atmosphere.
                      </p>

                      <div className="text-muted">
                        Availability: {room.availability}
                      </div>
                    </Col>

                    {/* Price + Status */}
                    <Col
                      md={2}
                      className="text-md-end mt-3 mt-md-0 position-relative"
                    >
                      <Badge
                        bg={room.status === "Available" ? "success" : "secondary"}
                        style={{
                          position: "absolute",
                          top: "-10px",
                          right: "0",
                        }}
                      >
                        {room.status}
                      </Badge>

                      <h5 className="fw-bold mt-4">
                        {room.price}
                        <span className="text-muted fs-6"> / night</span>
                      </h5>

                      <Button
                        size="sm"
                        variant="outline-success"
                        className="mt-2"
                      >
                        View Details
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}
